import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Tabs, Tab, Badge, Col, Row, Form, OverlayTrigger, Tooltip, Nav, Table, Spinner, Alert } from 'react-bootstrap';
import { AbonnementService } from '../../services/AbonnementService';
import { BrouillonService } from '../../services/BrouillonService';
import { EditionService } from '../../services/EditionService';
import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetails from '../../components/side-details/SideDetails';
import AbonnementDetails from '../../components/side-details/abonnement/abonnement-details/AbonnementDetails';
import BrouillonDetails from '../../components/side-details/brouillon/brouillon-details/BrouillonDetails';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import './Abonnements.scss';
import { PreferenceService } from '../../services/PreferenceService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../services/GlobalProvider";
import { getFormErrorMsg, formatTableHeadersFromPrefs, granted, getFile, currencyFormat } from '../../helper/Helper'
import Brouillons from "../../components/brouillons/Brouillons";
import YearMonthInput from "../../components/form-inputs/year-month-input/YearMonthInput";
import TagsFilter from "../../components/tags-filter/TagsFilter";


const Abonnements = () => {

  const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  const navigate = useNavigate();

  const [globalError, setGlobalError] = useState()
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentApiData, setCurrentApiData] = useState()
  const [isGetDataLoading, setIsGetDataLoading] = useState()
  const [isPDFLoading, setIsPDFLoading] = useState()
  const [sideWidth, setSideWidth] = useState()
  const [tableHeaders, setTableHeaders] = useState()
  const [checkedElementIdList, setCheckedElementIdList] = useState([])
  const [currentPagination, setCurrentPagination] = useState(1)
  const [isTableFilterVisible, setIsTableFilterVisible] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
  const [currentElement, setCurrentElement] = useState()
  const [dateExecutionBrouillons, setDateExecutionBrouillons] = useState("")
  const [currentTab, setCurrentTab] = useState()
  const [brouillonsGenerateResponse, setBrouillonsGenerateResponse] = useState();
  const [brouillonsValidateResponse, setBrouillonsValidateResponse] = useState();
  const [abonnementsEmailsResponse, setAbonnementsEmailsResponse] = useState();
  const [isPostbrouillonsGenerateLoading, setIsPostBrouillonsGenerateLoading] = useState();
  const [isPostbrouillonsValidateLoading, setIsPostBrouillonsValidateLoading] = useState();
  const [isPostEmailsLoading, setIsPostEmailsLoading] = useState();
  const [listeFiltre, setListeFiltre] = useState('programmes');

  let searchRef = useRef(null);
  let dataParams = useRef({});
  let abonnementsFilters = useRef({});
  let emailsFilters = useRef({});

  const [elementActions, setElementActions] = useState([]);

  useEffect(() => {
    if (globalContextLoaded) {
      defineElementActions(["editAbonnement", "duplicateAbonnement", "removeAbonnement"])
      searchParams.get('abonnementId') && getAbonnement(searchParams.get('abonnementId'))
      initPreferences()

      // Si un brouillon est en cours d'édition on redirige.
      if (!searchParams.get('factureId') && preferences.abonnements.currentDraft) {
        navigate(`/${folderDetails?.dossier?._id}/abonnements/brouillon?brouillonId=${preferences.abonnements.currentDraft}&from=abonnements`)
      }
    }
  }, [globalContextLoaded]);

  function defineElementActions(actionLabelList) {
    let newElementActions = []
    actionLabelList.map((actionLabel) => {
      if (actionLabel == "editAbonnement") {
        if (granted(grants, "abonnements.edit") && granted(grants, "brouillons.edit")) {
          newElementActions.push({ icon: "edit", title: "Modifier l'abonnement (crée un brouillon)", action: "editAbonnement" })
        }
      }
      if (actionLabel == "duplicateAbonnement") {
        if (granted(grants, "abonnements.edit") && granted(grants, "brouillons.edit")) {
          newElementActions.push({ icon: "file_copy", title: "Dupliquer (crée un brouillon)", action: "duplicateAbonnement" })
        }
      }
      if (actionLabel == "postAbonnementsBrouillonsValidate") {
        if (granted(grants, "brouillons.edit") && granted(grants, "factures.edit")) {
          newElementActions.push({ icon: "check_circle_outline", title: "Valider en facture", action: "postAbonnementsBrouillonsValidate" })
        }
      }
      if (actionLabel == "postAbonnementsBrouillonsGenerate") {
        if (granted(grants, "brouillons.edit")) {
          newElementActions.push({ icon: "check_circle_outline", title: "Générer le brouillon", action: "postAbonnementsBrouillonsGenerate" })
        }
      }
      if (actionLabel == "editBrouillon") {
        if (granted(grants, "brouillons.edit") && granted(grants, "factures.edit")) {
          newElementActions.push({ icon: "edit", title: "Modifier le brouillon", action: "editBrouillon" })
        }
      }
      if (actionLabel == "postFacturePrint") {
        newElementActions.push({ icon: "print", title: "Imprimer", action: "downloadPDF" })
      }
      if (actionLabel == "postAbonnementsEmails") {
        newElementActions.push({ icon: "send", title: "Envoyer par mail", action: "postAbonnementsEmails" })
      }
      if (actionLabel == "removeAbonnement") {
        if (granted(grants, "abonnements.remove")) {
          newElementActions.push({ icon: "delete_forever", title: "Supprimer", action: "removeAbonnementDialog" })
        }
      }
      if (actionLabel == "removeAbonnementBrouillon") {
        if (granted(grants, "brouillons.remove")) {
          newElementActions.push({ icon: "delete_forever", title: "Supprimer", action: "removeAbonnementBrouillonDialog" })
        }
      }
      setElementActions(newElementActions)
    })

  }

  function initPreferences() {
    resetAbonnementsParams()
    if (preferences?.abonnements['moisAbonnement']) {
      setTabAbonnementsSummary()
      setDateExecutionBrouillons(preferences.abonnements['moisAbonnement'] + '-01')
    } else {
      getAbonnements()
    }
  }

  // Todo : fusioner les deux méthodes
  function resetAbonnementsParams(avoidParamsList = []) { // avoidParamsList est la liste des paramètres à ne pas mettre à jour
    avoidParamsList.indexOf('mois_abonnement') == -1 && (dataParams.current['mois_abonnement'] = preferences.abonnements['moisAbonnement'] || null)
    dataParams.current['sort'] = preferences.abonnements['tableSort']
    dataParams.current['order'] = preferences.abonnements['tableOrder']
    dataParams.current['limit'] = preferences.abonnements['tableCount'] || 5
    dataParams.current['fields'] = Object.keys(preferences.abonnements['tableHeaders']).join(',') + ",interlocuteur,details" //todo : ajouter interlocuteur en bdd
    dataParams.current['filtre'] = null
    avoidParamsList.indexOf('search') == -1 && (dataParams.current['search'] = null)
    avoidParamsList.indexOf('filters') == -1 && (dataParams.current['filters'] = null)
    dataParams.current['force_resend'] = null
    setCurrentPagination(1)
    dataParams.current['start'] = 0
    setTableHeaders(formatTableHeadersFromPrefs(preferences.abonnements['tableHeaders'], parametres.abonnements['fieldsLabel']))
  }

  function resetEmailsParams(avoidParamsList = []) {
    avoidParamsList.indexOf('mois_abonnement') == -1 && (dataParams.current['mois_abonnement'] = preferences.abonnements['moisAbonnement'] || null)
    dataParams.current['sort'] = preferences.abonnements_mailing['tableSort']
    dataParams.current['order'] = preferences.abonnements_mailing['tableOrder']
    dataParams.current['limit'] = preferences.abonnements_mailing['tableCount'] || 5
    dataParams.current['fields'] = Object.keys(preferences.abonnements_mailing['tableHeaders']).join(',')
    dataParams.current['filtre'] = null
    avoidParamsList.indexOf('search') == -1 && (dataParams.current['search'] = null)
    avoidParamsList.indexOf('filters') == -1 && (dataParams.current['filters'] = null)
    dataParams.current['force_resend'] = null
    setCurrentPagination(1)
    dataParams.current['start'] = 0
    setTableHeaders(formatTableHeadersFromPrefs(preferences.abonnements_mailing['tableHeaders'], parametres.abonnements['fieldsLabel']))
  }

  function getAbonnement(abonnementId) {
    if (granted(grants, "abonnements.consult")) {
      AbonnementService.getAbonnement(folderDetails?.dossier?._id, abonnementId).then(res => {
        if (res.status == 204) {
          setGlobalError({ statusText: "L'abonnement demandé n'a pas été trouvé" })
        } else if (!res.data?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          changeCurrentElement(res.data.data)
        }
      }).catch(error => {
        setGlobalError(error)
      });
    }
  }

  function getAbonnements() {
    if (granted(grants, "abonnements.consult")) {
      setCheckedElementIdList([])
      setIsGetDataLoading(true)
      AbonnementService.getAbonnements(folderDetails?.dossier?._id, dataParams.current).then(res => {
        setCurrentApiData({
          data: res?.data?.data?.abonnements,
          total: res?.data?.data?.total
        })
        setIsGetDataLoading(false)
      }).catch(error => {
        setIsGetDataLoading(false)
        setGlobalError(error)
      });
    }
  }

  function getAbonnementsSummary() {
    if (granted(grants, "abonnements.consult")) {
      setCheckedElementIdList([])
      setBrouillonsGenerateResponse()
      setIsGetDataLoading(true)
      AbonnementService.getAbonnementsSummary(folderDetails?.dossier?._id, dataParams.current).then(res => {
        if (res.data.data.resume[dataParams.current['filtre']]) {
          setCurrentApiData({
            data: res.data.data[dataParams.current['filtre']].length > 0 ? res.data.data[dataParams.current['filtre']] : null,
            total: res.data.data.resume[dataParams.current['filtre']].count,
            resume: res.data.data.resume
          })
        } else {
          setCurrentApiData()
        }
        setIsGetDataLoading(false)
      }).catch(error => {
        setIsGetDataLoading(false)
        setGlobalError(error)
      });
    }
  }

  function getAbonnementsBrouillons() {
    setCheckedElementIdList([])
    setIsGetDataLoading(true)
    AbonnementService.getAbonnementsBrouillons(folderDetails?.dossier?._id, dataParams.current).then(res => {
      if (res.data.data) {
        setCurrentApiData({
          data: res.data.data.length > 0 ? res.data.data : null,
          total: null
        })
      } else {
        setCurrentApiData()
      }
      setIsGetDataLoading(false)
    }).catch(error => {
      setIsGetDataLoading(false)
      setGlobalError(error)
    });
  }

  function getAbonnementsEmails(mailsState) {
    setCheckedElementIdList([])
    setIsGetDataLoading(true)
    setAbonnementsEmailsResponse()
    AbonnementService.getAbonnementsEmails(folderDetails?.dossier?._id, dataParams.current).then(res => {
      if (res.data.data) {
        let data = res.data.data[mailsState]?.length > 0 ? res.data.data[mailsState] : null
        data?.map(d => {
          if (d?.interlocuteur?.mails.length == 0) {
            d.interlocuteur["isMailInvalid"] = true
          }
        })
        setCurrentApiData({
          data: data,
          total: res.data.data.resume[mailsState].count
        })
      } else {
        setCurrentApiData()
      }
      setIsGetDataLoading(false)
    }).catch(error => {
      setIsGetDataLoading(false)
      setGlobalError(error)
    });
  }

  function getAbonnementsListPDF(idList) {
    !idList && setIsPDFLoading(true)
    let params = {
      'start': 0,
      'search': dataParams.current.search,
      'sort': dataParams.current.sort,
      'order': dataParams.current.order,
      'filters': dataParams.current.filters,
      'mois_abonnement': dataParams.current.mois_abonnement,
      'filtre': dataParams.current.filtre
    }
    idList && (params['abonnements'] = idList)
    EditionService.getListe(folderDetails?.dossier?._id, params, "abonnements", "pdf").then(res => {
      setIsPDFLoading(false)
      if (!res?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(error => {
      setIsPDFLoading(false)
      setGlobalError(error)
    });
  }

  function downloadCheckedFactures(checkedElementIdList) {

    console.log("------currentApiData")
    console.log(currentApiData)
    console.log(checkedElementIdList)

    let factureIdList = []
    currentApiData?.data?.map(abonnement => {
      if (checkedElementIdList.includes(abonnement._id)) {
        factureIdList.push(abonnement.facture_id)
      }
    })

    let params = {}
    if (factureIdList?.length > 0) {
      params["filter"] = {}
      params["filter"]["_id"] = "=" + factureIdList.join(',')
    }

    EditionService.getFactures(folderDetails?.dossier?._id, params).then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function postAbonnementsBrouillonsGenerate(abonnement) {
    setIsPostBrouillonsGenerateLoading(true)

    let idList
    if (abonnement) {
      idList = [abonnement._id]
    } else if (checkedElementIdList.length > 0) {
      idList = checkedElementIdList
    } else {
      idList = []
    }

    let params = {
      mois_abonnement: dataParams.current.mois_abonnement,
      date_execution: dateExecutionBrouillons,
      abonnements: idList
    }

    /* Formatte les params "filters" pour le POST */
    if (dataParams?.current?.filters) {
      for (const [key, value] of Object.entries(dataParams.current.filters)) {
        let operations = []
        value.map(f => {
          operations.push(f.operator + f.value)
        })
        params[key] = operations.join(" ")
      }
    }
    AbonnementService.postAbonnementsBrouillonsGenerate(folderDetails?.dossier?._id, params).then(res => {
      reloadCurrentQuery()
      setIsPostBrouillonsGenerateLoading(false)
      setBrouillonsGenerateResponse(res?.data?.data)
    }).catch(error => {
      if (error?.response?.data?.data?.echecs) {
        setBrouillonsGenerateResponse(error?.response?.data?.data)
      } else {
        setGlobalError(error)
      }
      setIsPostBrouillonsGenerateLoading(false)
    });
  }

  function postAbonnementsBrouillonsValidate(brouillon) {
    setIsPostBrouillonsValidateLoading(true)

    let idList
    if (brouillon) {
      idList = [brouillon._id]
    } else if (checkedElementIdList.length > 0) {
      idList = checkedElementIdList
    } else {
      idList = []
    }

    let params = {
      mois_abonnement: dataParams.current.mois_abonnement,
      date_execution: dateExecutionBrouillons,
      brouillons: idList
    }
    /* Formatte les params "filters" pour le POST */
    /* todo : dans une fonction */
    if (dataParams?.current?.filters) {
      for (const [key, value] of Object.entries(dataParams.current.filters)) {
        let operations = []
        value.map(f => {
          operations.push(f.operator + f.value)
        })
        params[key] = operations.join(" ")
      }
    }
    AbonnementService.postAbonnementsBrouillonsValidate(folderDetails?.dossier?._id, params).then(res => {
      reloadCurrentQuery()
      setIsPostBrouillonsValidateLoading(false)
      setBrouillonsValidateResponse(res?.data?.data)
    }).catch(error => {
      if (error?.response?.data?.data?.echecs) {
        setBrouillonsValidateResponse(error?.response?.data?.data?.echecs)
      } else {
        setGlobalError(error)
      }
      setIsPostBrouillonsValidateLoading(false)
    });
  }

  function downloadPDF(abonnement) {
    EditionService.getFacture(folderDetails?.dossier?._id, abonnement?.facture_id, "pdf").then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(async (error) => {
      if (
        error.request.responseType === 'blob' &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf('json') != -1
      ) {
        setGlobalError({ response: JSON.parse(await error.response.data.text()) })
      } else {
        setGlobalError(error)
      }
    });
  }

  function postAbonnementsEmails(abonnement) {
    setIsPostEmailsLoading(true)

    let idList
    if (abonnement) {
      idList = [abonnement._id]
    } else if (checkedElementIdList.length > 0) {
      idList = checkedElementIdList
    } else {
      idList = []
    }

    let params = {
      mois_abonnement: dataParams.current.mois_abonnement,
      abonnements: idList
    }

    if (currentTab == "emailsExpedies") {
      params['force_resend'] = true
    }

    AbonnementService.postAbonnementsEmails(folderDetails?.dossier?._id, params).then(res => {
      reloadCurrentQuery()
      setIsPostEmailsLoading(false)
      setAbonnementsEmailsResponse(res)
    }).catch(error => {
      setGlobalError(error)
      setIsPostEmailsLoading(false)
    });
  }

  function removeBrouillon(brouillon) {
    BrouillonService.removeBrouillon(folderDetails?.dossier?._id, brouillon._id).then(res => {
      setConfirmDialog({ show: false });
      reloadCurrentQuery()
      changeCurrentElement()
      setSideWidth()
      uncheckElementList([brouillon._id])
    }).catch(err => {
      setConfirmDialog({
        ...confirmDialog,
        dialogInfos: { ...confirmDialog.dialogInfos, error: err }
      })
    });
  }

  function removeAbonnementList(abonnementIdList) {
    AbonnementService.removeAbonnements(folderDetails?.dossier?._id, abonnementIdList).then(res => {
      setConfirmDialog({ show: false });
      reloadCurrentQuery()
      changeCurrentElement()
      setSideWidth()
      uncheckElementList(abonnementIdList)
    }).catch(err => {
      setConfirmDialog({
        ...confirmDialog,
        dialogInfos: { ...confirmDialog.dialogInfos, error: err }
      })
    });
  }

  function removeBrouillonList(brouillonIdList) {
    BrouillonService.removeBrouillons(folderDetails?.dossier?._id, brouillonIdList).then(res => {
      setConfirmDialog({ show: false });
      reloadCurrentQuery()
      changeCurrentElement()
      setSideWidth()
      uncheckElementList(brouillonIdList)
    }).catch(err => {
      setConfirmDialog({
        ...confirmDialog,
        dialogInfos: { ...confirmDialog.dialogInfos, error: err }
      })
    });
  }

  function uncheckElementList(idList) {
    let checkedElementIdListCopy = [...checkedElementIdList];
    idList.map(id => {
      let index = checkedElementIdListCopy.indexOf(id)
      if (index >= 0) {
        checkedElementIdListCopy.splice(index, 1)
      }
    })
    setCheckedElementIdList(checkedElementIdListCopy)
  }

  function updatePreference(prefs, prefLabel) {
    //let prefKey = (currentTab == "emailsExpediables" || currentTab == "emailsExpedies") ? "abonnements_mailing" : "abonnements"
    PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { [prefLabel]: prefs } }).then(res => {
      getPreferences()
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function changeCurrentElement(element) {
    (!currentTab && element?._id) ? setSearchParams({ abonnementId: element._id }) : setSearchParams(searchParams.delete('abonnementId'))
    setCurrentElement(element)
  }

  function changeTableHeaders(e) {
    setTableHeaders(e)
    let newHeadersObject = {}
    e.forEach(object => {
      newHeadersObject[object['dataTarget']] = { position: object['position'], hidden: object['hidden'] }
    });
    const prefLabel = (currentTab == "emailsExpediables" || currentTab == "emailsExpedies") ? "abonnements_mailing" : "abonnements"
    updatePreference({ ["tableHeaders"]: newHeadersObject }, prefLabel)
  }

  function changeSortOrder(s, o) {
    dataParams.current['sort'] = s
    dataParams.current['order'] = o
    const prefLabel = (currentTab == "emailsExpediables" || currentTab == "emailsExpedies") ? "abonnements_mailing" : "abonnements"
    updatePreference({ ["tableSort"]: s, ["tableOrder"]: o }, prefLabel)
    reloadCurrentQuery()
  }

  function changePagination(p) {
    setCurrentPagination(p)
    dataParams.current['start'] = (dataParams.current.limit * p) - dataParams.current.limit
    reloadCurrentQuery()
  }

  function changeLimit(l) {
    dataParams.current['limit'] = l
    const prefLabel = (currentTab == "emailsExpediables" || currentTab == "emailsExpedies") ? "abonnements_mailing" : "abonnements"
    updatePreference({ ["tableCount"]: l }, prefLabel)
    changePagination(1)
  }

  let searchTimeOut;
  function changeSearchValue(value) {
    window.clearTimeout(searchTimeOut);
    searchTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      dataParams.current['start'] = 0
      dataParams.current['search'] = value ? value : ""
      searchRef.current.value = value ? value : ""
      reloadCurrentQuery()
    }, 1000);
  }

  let filtersTimeOut;
  function changeFilters(f) {
    window.clearTimeout(filtersTimeOut);
    filtersTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      dataParams.current['start'] = 0
      dataParams.current['filters'] = f

      /* Le filtre des tags s'applique aux requetes "emails" et "abonnements" */
      if (f?.['filter[client.tags._id]']) {
        emailsFilters.current['filter[client.tags._id]'] = f['filter[client.tags._id]']
        abonnementsFilters.current['filter[client.tags._id]'] = f['filter[client.tags._id]']
      } else {
        delete emailsFilters.current['filter[client.tags._id]']
        delete abonnementsFilters.current['filter[client.tags._id]']
      }

      if (currentTab == "emailsExpediables" || currentTab == "emailsExpedies") {
        emailsFilters.current = f ? f : {}
      } else {
        abonnementsFilters.current = f ? f : {}
      }

      reloadCurrentQuery()
    }, 1000);
  }

  function clearFilters() {
    setCurrentPagination(1)
    dataParams.current['start'] = 0
    dataParams.current['filters'] = null
    emailsFilters.current = {}
    abonnementsFilters.current = {}
    setIsTableFilterVisible(false)
    reloadCurrentQuery()
  }


  function changeTagIdList(tagIdList) {
    let filtersCopy = { ...dataParams?.current['filters'] }
    if (tagIdList.length > 0) {

      let tagArray = []
      tagIdList.map(tagId => {
        tagArray.push(tagId)
      })

      if (!filtersCopy[`filter[client.tags._id]`]) {
        filtersCopy[`filter[client.tags._id]`] = []
      }

      filtersCopy[`filter[client.tags._id]`] = [
        {
          "operation": "equal_to",
          "operator": "=",
          "value": tagArray.toString()
        }
      ]
      changeFilters(filtersCopy)
      setIsTableFilterVisible(true)
    } else {
      if (filtersCopy && filtersCopy[`filter[client.tags._id]`]) {
        delete filtersCopy[`filter[client.tags._id]`]
        changeFilters(filtersCopy)
      }
    }
  }

  function reloadCurrentQuery() {
    if (!currentTab) {
      getAbonnements()
    }
    if (currentTab == "liste") {
      getAbonnementsSummary()
    }
    if (currentTab == "summary") {
      getAbonnementsSummary()
    }
    if (currentTab == "brouillons") {
      getAbonnementsBrouillons()
    }
    if (currentTab == "emailsExpediables") {
      getAbonnementsEmails("expediables")
    }
    if (currentTab == "emailsExpedies") {
      getAbonnementsEmails("expedies")
    }
  }

  function onTabChange() {
    reloadCurrentQuery()
  }

  function closeSide() {
    setCurrentElement()
  }

  function openBrouillon(brouillonId, documentType, isNewTab) {
    if (isNewTab) {
      window.open(`/${folderDetails?.dossier?._id}/${documentType}/brouillon?brouillonId=${brouillonId}&from=abonnements`, '_blank')
    } else {
      navigate(`/${folderDetails?.dossier?._id}/${documentType}/brouillon?brouillonId=${brouillonId}&from=abonnements`)
    }
  }

  function createNewAbonnement() {
    AbonnementService.postAbonnement(folderDetails?.dossier?._id, { abonnements: [{ "type": "abonnement" }] }).then(res => {
      for (const brouillonId in res.data.data.brouillons) {
        openBrouillon(brouillonId, "abonnements")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function removeAbonnementListDialog(abonnementIdList) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer ${abonnementIdList.length} abonnement(s) ?`,
        description: 'Voulez vous supprimer les abonnements sélectionnés ?',
        actionName: 'Supprimer la sélection',
        btnVariant: 'danger',
        element: abonnementIdList,
        error: false,
        confirmAction: 'removeAbonnementList'
      }
    })
  }

  function removeBrouillonListDialog(brouillonIdList) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer ${brouillonIdList.length} brouillon(s) ?`,
        description: 'Voulez vous supprimer les brouillons sélectionnés ?',
        actionName: 'Supprimer la sélection',
        btnVariant: 'danger',
        element: brouillonIdList,
        error: false,
        confirmAction: 'removeBrouillonList'
      }
    })
  }

  function removeAbonnementDialog(abonnement) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: abonnement.nom,
        description: 'Voulez vous supprimer cet abonnement ?',
        actionName: 'Supprimer',
        btnVariant: 'danger',
        element: [abonnement._id],
        error: false,
        confirmAction: 'removeAbonnementList'
      }
    })
  }

  function removeAbonnementBrouillonDialog(brouillon) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: brouillon.client_nom,
        description: 'Voulez vous supprimer ce brouillon ?',
        actionName: 'Supprimer',
        btnVariant: 'danger',
        element: brouillon,
        error: false,
        confirmAction: 'removeBrouillon'
      }
    })
  }

  function editAbonnement(abonnement, isNewTab) {
    AbonnementService.updateAbonnement(folderDetails?.dossier?._id, abonnement._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "abonnements", isNewTab)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function editBrouillon(brouillon) {
    openBrouillon(brouillon._id, "factures", false)
  }

  function duplicateAbonnement(abonnement) {
    AbonnementService.duplicateAbonnement(folderDetails?.dossier?._id, abonnement._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "abonnements")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function onChangeMoisAbonnementParam(value) {

    // todo : retirer le mois en cours des préférences
    // close -> unsetTabs()

    let formattedDateMoisAbonnement = ""

    if (value) {
      formattedDateMoisAbonnement = value ? value.split('/').reverse().join('-') : ""
    } else {
      const dateToday = new Date()
      let currentMonth = dateToday.getMonth()
      let currentYear = dateToday.getFullYear()
      if (currentMonth < 10) { currentMonth = '0' + currentMonth; }
      formattedDateMoisAbonnement = `${currentYear}-${currentMonth}`
    }

    dataParams.current['mois_abonnement'] = formattedDateMoisAbonnement
    setDateExecutionBrouillons(formattedDateMoisAbonnement + '-01')
    if (currentTab) {
      setCurrentPagination(1)
      dataParams.current['start'] = 0
      reloadCurrentQuery()
    } else {
      setTabAbonnementsSummary()
    }
    updatePreference({ ["moisAbonnement"]: formattedDateMoisAbonnement }, "abonnements")

  }

  /*   function onChangeMoisAbonnementParam(value) {
      let formattedDateMoisAbonnement = value ? value.split('/').reverse().join('-') : ""
      if (!value) {
        unsetTabs()
      } else {
        dataParams.current['mois_abonnement'] = formattedDateMoisAbonnement
        setDateExecutionBrouillons(formattedDateMoisAbonnement + '-01')
        if (currentTab) {
          setCurrentPagination(1)
          dataParams.current['start'] = 0
          reloadCurrentQuery()
        } else {
          setTabAbonnementsMoisListe(formattedDateMoisAbonnement)
        }
      }
      updatePreference({ ["moisAbonnement"]: formattedDateMoisAbonnement }, "abonnements")
  
    } */


  function unsetTabs() {
    updatePreference({ ["moisAbonnement"]: "" }, "abonnements")
    defineElementActions(["editAbonnement", "duplicateAbonnement", "removeAbonnement"])
    resetAbonnementsParams(['search', 'filters', 'mois_abonnement'])
    dataParams.current['filters'] = abonnementsFilters.current
    dataParams.current['mois_abonnement'] = null
    setCurrentTab()
    setDateExecutionBrouillons("")
    getAbonnements()
  }

  /*     function setTabAbonnementsMoisListe(moisAboOnInit) {
        defineElementActions(["editAbonnement", "duplicateAbonnement", "removeAbonnement"])
        resetAbonnementsParams(['search', 'filters', 'mois_abonnement'])
        dataParams.current['filters'] = abonnementsFilters.current
        setCurrentTab("liste")
        dataParams.current.filtre = listeFiltre ? listeFiltre : 'programmes'
        if (moisAboOnInit) { dataParams.current['mois_abonnement'] = moisAboOnInit }
        getAbonnementsSummary()
      } */

  function setTabAbonnementsSummary() {
    defineElementActions(["postAbonnementsBrouillonsGenerate", "editAbonnement", "duplicateAbonnement", "removeAbonnement"])
    resetAbonnementsParams(['search', 'filters', 'mois_abonnement'])
    dataParams.current['filters'] = abonnementsFilters.current
    setBrouillonsGenerateResponse()
    setCurrentTab("summary")
    changeListeFiltre('programmes')
    getAbonnementsSummary()
  }

  function setTabAbonnementsBrouillon() {
    defineElementActions(["postAbonnementsBrouillonsValidate", "editBrouillon", "removeAbonnementBrouillon"])
    resetAbonnementsParams(['search', 'filters', 'mois_abonnement'])
    dataParams.current['filters'] = abonnementsFilters.current
    setBrouillonsValidateResponse()
    setCurrentTab("brouillons")
    dataParams.current.filtre = null
    getAbonnementsBrouillons()
  }

  function setTabAbonnementsEmailsExpediables() {
    defineElementActions(["postAbonnementsEmails", "editAbonnement", "postFacturePrint"])
    resetEmailsParams(['search', 'filters', 'mois_abonnement'])
    dataParams.current['filters'] = emailsFilters.current
    setAbonnementsEmailsResponse()
    setCurrentTab("emailsExpediables")
    dataParams.current.filtre = "expediables"
    getAbonnementsEmails("expediables")
  }

  function setTabAbonnementsEmailsExpedies() {
    defineElementActions(["postAbonnementsEmails", "postFacturePrint"])
    resetEmailsParams(['search', 'filters', 'mois_abonnement'])
    dataParams.current['filters'] = emailsFilters.current
    setCurrentTab("emailsExpedies")
    dataParams.current.filtre = "expedies"
    getAbonnementsEmails("expedies")
  }

  function changeListeFiltre(filtre) {
    setListeFiltre(filtre)
    setCurrentPagination(1)
    dataParams.current['start'] = 0
    dataParams.current.filtre = filtre
    getAbonnementsSummary()
  }

  function getEchecErrorList(errData) {
    let errList = []
    getDeepKeys(errData)
    function getDeepKeys(obj) {
      for (var key in obj) {
        if (typeof obj[key] === 'string' && obj[key].substring(0, 9) == "Erreur : ") {
          let splitString = obj[key].split("Erreur : ");
          splitString.forEach((str) => {
            if (str != "") {
              errList.push(str)
            }
          });
        }
        /* if (obj.length == 1 && typeof obj[key] === 'string' && obj[key].substring(0, 9) != "Erreur : ") {
            errList.push(obj[key])
        } */
        if (typeof obj[key] === "object") {
          getDeepKeys(obj[key])
        }
      }
      return
    }
    return errList
  }

  return (
    <Container fluid id="Abonnements" className="py-4">

      <ConfirmDialog
        show={confirmDialog.show}
        dialogInfos={confirmDialog.dialogInfos}
        setCancel={() => setConfirmDialog({ show: false })}
        setConfirm={(a, e) => eval(a)(e)}
      />

      <div className="pb-2 d-flex align-items-center justify-content-between">
        <h4 className="m-0">Abonnements</h4>
        {/* Brouillons en cours */}
        <div>
          <Brouillons brouillonTypes={["abonnement"]} openBrouillon={b => openBrouillon(b, "abonnements")} grantedConsult={granted(grants, "brouillons.consult")} grantedEdit={granted(grants, "brouillons.edit")} grantedRemove={granted(grants, "brouillons.remove")} />
          {granted(grants, "abonnements.edit") &&
            <Button variant="primary" onClick={() => createNewAbonnement()}>Créer un abonnement</Button>
          }
        </div>
      </div>

      <ErrorManager error={globalError} fixed="true" />

      <Row>
        <Col xs="12">
          {granted(grants, "abonnements.consult") ?
            <>
              <Row className="mb-4 gx-2">
                <Col sm="12" lg="3" className="mb-2">
                  <InputGroup className="w-auto">
                    <i className="material-icons input-icon text-gray-400">search</i>
                    <FormControl
                      className="input-icon-space rounded-start"
                      placeholder="Recherche globale"
                      type="text"
                      onChange={e => changeSearchValue(e.target.value)}
                      ref={searchRef}
                    />
                    {dataParams.current['search'] &&
                      <Button onClick={() => changeSearchValue()} variant="gray-100" className="border border-start-0">
                        <i className="material-icons i-lg">clear</i>
                      </Button>
                    }
                  </InputGroup>
                </Col>
                <Col sm="12" md="auto" lg="auto" className="mb-2 d-flex align-items-center">
                  <InputGroup className="me-2 w-auto">
                    <TagsFilter btnClassName="rounded-end-0" btnTitle="Filtrer par tags client" documentType="clients" changeTagIdList={tagIdList => changeTagIdList(tagIdList)} parentFilters={dataParams?.current['filters']} />
                    {(Object.keys(abonnementsFilters.current).length == 0 && Object.keys(emailsFilters.current).length == 0) &&
                      <OverlayTrigger placement="right" delay={{ show: 800 }} overlay={<Tooltip>Filtres de recherche</Tooltip>}>
                        <Button variant="secondary" onClick={() => setIsTableFilterVisible(!isTableFilterVisible)}>
                          <i className="material-icons i-lg">filter_alt</i>
                        </Button>
                      </OverlayTrigger>
                    }
                    {(Object.keys(abonnementsFilters.current).length > 0 || Object.keys(emailsFilters.current).length > 0) &&
                      <Button className="d-flex" variant="warning" onClick={() => clearFilters()}>
                        Suppr. les filtres
                        <i className="material-icons i-lg ms-2 d-inline-flex">clear</i>
                      </Button>
                    }
                  </InputGroup>
                  <ColManager tableHeaders={tableHeaders} changeTableHeaders={e => changeTableHeaders(e)} />
                </Col>

                {currentTab ?
                  <Col sm="12" md="auto" lg="auto" className="mb-2 d-flex align-items-center">
                    <Button variant="dark" onClick={() => unsetTabs()}>Afficher tous les abonnements</Button>
                  </Col>
                  :
                  <Col sm="12" md="auto" lg="auto" className="mb-2 d-flex align-items-center">
                    <Button variant="dark" onClick={() => onChangeMoisAbonnementParam()}>Générer des abonnements</Button>
                  </Col>
                }

                <Col sm="12" lg="auto" className="mb-2 d-flex align-items-center">
                  <Button disabled={isPDFLoading} variant="secondary" className="me-2" onClick={() => getAbonnementsListPDF()}>
                    {!isPDFLoading && <i className="material-icons i-lg float-start me-2">print</i>}
                    {isPDFLoading && <Spinner animation="border" size="sm" className="me-2" />}
                    Imprimer la liste <span className="badge rounded-pill text-bg-light">{currentApiData?.total}</span>
                  </Button>
                  {checkedElementIdList?.length > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="dark">
                        {checkedElementIdList.length} Sélectionné{checkedElementIdList?.length > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <>
                          <Dropdown.Item onClick={() => getAbonnementsListPDF(checkedElementIdList)}>Imprimer la liste sélectionnée</Dropdown.Item>
                          {(currentTab == "emailsExpediables" || currentTab == "emailsExpedies") &&
                            <Dropdown.Item onClick={() => downloadCheckedFactures(checkedElementIdList)}>Imprimer les factures</Dropdown.Item>
                          }
                          <Dropdown.Divider />
                          {granted(grants, "abonnements.remove") &&
                            <>
                              {currentTab == "brouillons" &&
                                <Dropdown.Item className="text-danger" onClick={() => removeBrouillonListDialog(checkedElementIdList)}>Supprimer</Dropdown.Item>
                              }
                              {currentTab != "brouillons" &&
                                <Dropdown.Item className="text-danger" onClick={() => removeAbonnementListDialog(checkedElementIdList)}>Supprimer</Dropdown.Item>
                              }
                            </>
                          }
                        </>
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </Col>

              </Row>
              {currentTab &&
                <Row className="mb-3 mt-4">
                  <Col sm="12" md="4" lg="3">
                    <div /* onClick={() => setTabAbonnementsMoisListe()} */ className={"cursor-default rounded bg-gray-100 d-flex flex-column border h-100 p-3 "}>
                      <span className="fw-bold text-dark mb-2">Choisir une date</span>
                      <YearMonthInput isInvalid={false} disabled={isGetDataLoading} placeHolder="Sélectionner un mois" value={dataParams?.current?.mois_abonnement?.split('-').reverse().join('/')} onChange={v => onChangeMoisAbonnementParam(v)} />
                    </div>
                  </Col>
                  <Col sm="12" md="8" lg="9">
                    <Nav variant="pills" activeKey={dataParams.current.filtre}>
                      <Nav.Item className="tab-nav">
                        <Nav.Link onClick={() => setTabAbonnementsSummary()} className={"tab-width bg-primary-100 d-flex flex-column ms-2 h-100 p-3 " + (currentTab == "summary" ? "bg-primary-600 text-white" : "")}>
                          <span className="align-self-start small mb-2 px-2 py-1 bg-primary-200 text-primary-800 rounded-1">Étape 1</span>
                          <span className="fw-bold">Abonnements en attente {/* ({abonnements?.resume?.attentes?.count}) */}</span>
                          <span className="small">
                            Transformez des abonnements en brouillons de factures.
                          </span>
                          {/* {abonnements?.resume?.attentes?.total_ttc != null &&
                            <span className="">
                              Total TTC : {currencyFormat(abonnements?.resume.attentes.total_ttc)}
                            </span>
                          } */}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="tab-nav">
                        <Nav.Link onClick={() => setTabAbonnementsBrouillon()} className={"tab-width bg-primary-100 d-flex flex-column ms-2 h-100 p-3 " + (currentTab == "brouillons" ? "bg-primary-600 text-white" : "")}>
                          <span className="align-self-start small mb-2 px-2 py-1 bg-primary-200 text-primary-800 rounded-1">Étape 2</span>
                          <span className="fw-bold">Abonnements à valider</span>
                          <span className="small">
                            Corrigez ou modifiez les brouillons de votre choix, puis validez-les en factures.
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="tab-nav">
                        <Nav.Link onClick={() => setTabAbonnementsEmailsExpediables()} className={"tab-width bg-primary-100 d-flex flex-column ms-2 h-100 p-3 " + (currentTab == "emailsExpediables" ? "bg-primary-600 text-white" : "")}>
                          <span className="align-self-start small mb-2 px-2 py-1 bg-primary-200 text-primary-800 rounded-1">Étape 3</span>
                          <span className="fw-bold">Factures prêtes à l'envoi.</span>
                          <span className="small">
                            Envoyez les factures d'abonnements par mail et consultez les factures envoyées.
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="tab-nav">
                        <Nav.Link onClick={() => setTabAbonnementsEmailsExpedies()} className={"tab-width bg-primary-100 d-flex flex-column ms-2 h-100 p-3 " + (currentTab == "emailsExpedies" ? "bg-primary-600 text-white" : "")}>
                          <span className="align-self-start small mb-2 px-2 py-1 bg-primary-200 text-primary-800 rounded-1">Étape 4</span>
                          <span className="fw-bold">Factures envoyées</span>
                          <span className="small">
                            Factures envoyées aux clients.
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                </Row>
              }
              <Row className="mt-2">

                {/* Body -> Actions des tabs */}
                {currentTab == "liste" &&
                  <Col xs="4" lg="3" xl="2">
                    <div className="p-3 border rounded">
                      <span className={"d-flex cursor-pointer p-2 rounded w-100 mb-2 " + (listeFiltre == "programmes" ? "text-white bg-primary" : "bg-primary-100 text-primary")} onClick={() => changeListeFiltre("programmes")}>Programmés <Badge className="d-flex align-items-center ms-auto" bg="primary-400">{currentApiData?.resume?.programmes?.count}</Badge></span>
                      <span className={"d-flex cursor-pointer p-2 rounded w-100 mb-2 " + (listeFiltre == "suspendus" ? "text-white bg-primary" : "bg-primary-100 text-primary")} onClick={() => changeListeFiltre("suspendus")}>Suspendus <Badge className="d-flex align-items-center ms-auto" bg="primary-400">{currentApiData?.resume?.suspendus?.count}</Badge></span>
                      <span className={"d-flex cursor-pointer p-2 rounded w-100 mb-2 " + (listeFiltre == "generes" ? "text-white bg-primary" : "bg-primary-100 text-primary")} onClick={() => changeListeFiltre("generes")}>Générés <Badge className="d-flex align-items-center ms-auto" bg="primary-400">{currentApiData?.resume?.generes?.count}</Badge></span>
                    </div>
                  </Col>
                }
                {currentTab == "summary" &&
                  <Col xs="4" lg="3" xl="2">

                    {granted(grants, "brouillons.edit") ?
                      <div className="p-3 border rounded">

                        <span className={"d-flex cursor-pointer p-2 rounded w-100 mb-2 " + (listeFiltre == "programmes" ? "text-white bg-primary" : "bg-primary-100 text-primary")} onClick={() => changeListeFiltre("programmes")}>Programmés <Badge className="d-flex align-items-center ms-auto" bg="primary-400">{currentApiData?.resume?.programmes?.count}</Badge></span>
                        <span className={"d-flex cursor-pointer p-2 rounded w-100 mb-2 " + (listeFiltre == "attentes" ? "text-white bg-primary" : "bg-primary-100 text-primary")} onClick={() => changeListeFiltre("attentes")}>En attente <Badge className="d-flex align-items-center ms-auto" bg="primary-400">{currentApiData?.resume?.attentes?.count}</Badge></span>
                        <span className={"d-flex cursor-pointer p-2 rounded w-100 mb-2 " + (listeFiltre == "suspendus" ? "text-white bg-primary" : "bg-primary-100 text-primary")} onClick={() => changeListeFiltre("suspendus")}>Suspendus <Badge className="d-flex align-items-center ms-auto" bg="primary-400">{currentApiData?.resume?.suspendus?.count}</Badge></span>


                        <Form.Group className="mb-3 mt-3">
                          <Form.Label>Date d'exécution :</Form.Label>
                          <Form.Control value={dateExecutionBrouillons} placeholder="Date d'exécution" onChange={e => setDateExecutionBrouillons(e.target.value)} type="date" />
                        </Form.Group>

                        <Button className="mb-3" onClick={() => postAbonnementsBrouillonsGenerate()} variant="primary" disabled={isGetDataLoading || isPostbrouillonsGenerateLoading}>
                          <span>Générer {checkedElementIdList.length > 0 ? (checkedElementIdList.length + " brouillons(s)") : "les brouillons"}</span>
                        </Button>

                      </div>
                      :
                      <div className="bg-gray-100 text-gray-600 p-2 w-100 rounded">
                        <em>- Vous n'avez pas les droits pour générer les brouillons. -</em>
                      </div>
                    }
                  </Col>
                }
                {currentTab == "brouillons" &&
                  <Col xs="4" lg="3" xl="2">
                    {(granted(grants, "brouillons.edit") && granted(grants, "factures.edit")) ?

                      <div className="p-3 border rounded">

                        <Form.Group className="mb-3">
                          <Form.Label>Date d'exécution :</Form.Label>
                          <Form.Control value={dateExecutionBrouillons} placeholder="Date d'exécution" onChange={e => setDateExecutionBrouillons(e.target.value)} type="date" />
                        </Form.Group>

                        <Button className="mb-3" onClick={() => postAbonnementsBrouillonsValidate()} variant="primary" disabled={isGetDataLoading || isPostbrouillonsValidateLoading}>
                          <span>Valider {checkedElementIdList.length > 0 ? (checkedElementIdList.length + " brouillons(s)") : "les brouillons"}</span>
                        </Button>

                      </div>
                      :
                      <div className="bg-gray-100 text-gray-600 p-2 w-100 rounded">
                        <em>- Vous n'avez pas les droits pour valider les brouillons. -</em>
                      </div>
                    }

                  </Col>
                }
                {currentTab == "emailsExpediables" &&
                  <Col xs="4" lg="3" xl="2">
                    <div className="p-3 border rounded">
                      <h6 className="mb-3">Envoi des mails :</h6>
                      <Button className="mb-3" onClick={() => postAbonnementsEmails()} variant="primary" disabled={isGetDataLoading || isPostEmailsLoading}>
                        <span>Envoyer {checkedElementIdList.length > 0 ? (checkedElementIdList.length + " email(s)") : "tous les emails"}</span>
                      </Button>
                    </div>
                  </Col>
                }
                {currentTab == "emailsExpedies" &&
                  <Col xs="4" lg="3" xl="2">
                    <div className="p-3 border rounded">
                      <h6 className="mb-3">Envoi des mails :</h6>
                      <Button className="mb-3" onClick={() => postAbonnementsEmails()} variant="primary" disabled={isGetDataLoading || isPostEmailsLoading}>
                        <span>Forcer le renvoi des emails</span>
                      </Button>
                    </div>
                  </Col>
                }

                <Col xs={currentTab ? "8" : "12"} lg={currentTab ? "9" : "12"} xl={currentTab ? "10" : "12"}>
                  <div className="bg-white rounded border">
                    {(currentTab == "summary" && brouillonsGenerateResponse?.resume?.brouillons > 0) &&
                      <Alert variant="success" className="m-3">
                        {brouillonsGenerateResponse?.resume?.brouillons} brouillon(s) généré(s) avec succès.
                      </Alert>
                    }
                    {(currentTab == "brouillons" && brouillonsValidateResponse?.resume?.facture_abonnement > 0) &&
                      <Alert variant="success" className="m-3">
                        {brouillonsValidateResponse?.resume?.facture_abonnement} facture(s) générée(s) avec succès.
                      </Alert>
                    }
                    {(currentTab == "emailsExpediables" && abonnementsEmailsResponse?.data?.data && Object.keys(abonnementsEmailsResponse?.data?.data).length > 0) &&
                      <Alert variant="success" className="m-3">
                        {Object.keys(abonnementsEmailsResponse?.data?.data).length} email(s) envoyé(s).
                      </Alert>
                    }
                    {/* aaaaaaaaaaaaaaa */}
                    {(currentTab == "emailsExpedies" && abonnementsEmailsResponse?.data?.data && Object.keys(abonnementsEmailsResponse?.data?.data).length > 0) &&
                      <Alert variant="success" className="m-3">
                        {Object.keys(abonnementsEmailsResponse?.data?.data).length} email(s) envoyé(s).
                      </Alert>
                    }
                    {(currentTab == "summary" && brouillonsGenerateResponse?.echecs) &&
                      <div className="bg-warning-subtle p-3 rounded m-3 border border-warning">
                        <h6>Attention : Ces abonnements n'ont pas pu être générés en brouillons :</h6>
                        <Table variant="warning">
                          <thead>
                            <tr>
                              <th className="small">Client</th>
                              <th className="small">Erreurs</th>
                              <th className="small">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(brouillonsGenerateResponse.echecs).map((key, index) => (
                              <tr>
                                <td>{brouillonsGenerateResponse.echecs[key]?.details?.client_nom}</td>
                                <td>
                                  <p className="m-0 fw-bold">{brouillonsGenerateResponse.echecs[key]?.erreur}</p>
                                  {getEchecErrorList(brouillonsGenerateResponse.echecs[key]?.details).map(err => (
                                    <p className="m-0">{err}</p>
                                  ))}
                                </td>
                                <td>
                                  <Button onClick={() => editAbonnement({ _id: key }, true)} variant="secondary" size="sm" className="d-inline-flex align-items-center">
                                    Corriger l'abonnement
                                    <i className="d-inline-flex ms-1 material-icons">open_in_new</i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    }

                    {(currentTab == "brouillons" && brouillonsValidateResponse?.echecs) &&
                      <div className="bg-warning-subtle p-3 rounded m-3 border border-warning">
                        <h6>Attention : Ces brouillons n'ont pas pu être générés en facture :</h6>
                        <Table variant="warning">
                          <thead>
                            <tr>
                              <th className="small">Client</th>
                              <th className="small">Erreurs</th>
                              <th className="small">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.keys(brouillonsValidateResponse?.echecs).map((key, index) => (
                              <tr>
                                <td>{brouillonsValidateResponse.echecs[key]?.details?.facture_abonnement?.client_nom}</td>
                                <td>
                                  <p className="m-0 fw-bold">{brouillonsValidateResponse.echecs[key]?.erreur}</p>
                                  {getEchecErrorList(brouillonsValidateResponse.echecs[key]?.details).map(err => (
                                    <p className="m-0">{err}</p>
                                  ))}
                                </td>
                                <td>
                                  <Button href={`/${folderDetails?.dossier?._id}/factures/brouillon?brouillonId=${brouillonsValidateResponse.echecs[key]?.brouillon_id}`} target="_blank" variant="secondary" size="sm" className="d-inline-flex align-items-center">
                                    Corriger le brouillon
                                    <i className="d-inline-flex ms-1 material-icons">open_in_new</i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    }
                    <DynamicTable
                      isDataLoading={isGetDataLoading}
                      elementActions={elementActions}
                      setElementAction={(a, e) => eval(a)(e)}
                      sideWidth={sideWidth}
                      tableHeaders={tableHeaders}
                      tableDataList={currentApiData?.data}
                      currentElement={currentElement}
                      changeCurrentElement={e => changeCurrentElement(e)}
                      checkedElementIdList={checkedElementIdList}
                      setCheckedElementIdList={e => setCheckedElementIdList(e)}
                      changeFilters={f => changeFilters(f)}
                      isTableFilterVisible={isTableFilterVisible}
                      changeSortOrder={(s, o) => changeSortOrder(s, o)}
                      params={dataParams.current}
                    />
                    {!isGetDataLoading &&
                      <Pagination className="m-3" itemsLength={currentApiData?.total} elementsPerPage={dataParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit showDefinePage changeLimit={l => changeLimit(l)} />
                    }
                  </div>
                </Col>

              </Row>
            </>
            :
            <Col>
              <em className="py-1 px-2 bg-gray-100 rounded mt-2">- Vous n'avez pas les droits d'accès à cette ressource -</em>
            </Col>
          }

          {currentElement &&
            <SideDetails
              avoidHistory={currentTab}
              currentElement={{ id: currentElement?._id, label: new Date(currentElement?.date).toLocaleString(), title: currentElement?.client_nom }}
              changeCurrentElement={e => changeCurrentElement(e)}
              setSideClose={closeSide}
              setSideWidth={e => setSideWidth(e)}
              detailsComponent={
                currentElement.type == "facture_abonnement" ?
                  <BrouillonDetails folderId={folderDetails?.dossier?._id} brouillonId={currentElement._id} elementActions={elementActions} setElementAction={(a, e) => eval(a)(e)} />
                  :
                  <>
                    {granted(grants, "abonnements.consult") &&
                      <AbonnementDetails folderId={folderDetails?.dossier?._id} abonnementId={currentElement._id} elementActions={elementActions} setElementAction={(a, e) => eval(a)(e)} onTabChange={() => onTabChange()} />
                    }
                  </>
              }
            />
          }
        </Col>
      </Row>

    </Container>


  );
}

export default Abonnements;